// Buscas recentes do Rastreamento, por usuário, no localStorage do navegador.
//
// Guarda só o necessário para refazer a busca e mostrar a linha (tipo, valor,
// NF, rota, status na hora da consulta). O status é uma FOTO do momento da
// busca, não o atual; a tela mostra quando foi e, ao clicar, consulta de novo.
// Nada disso vai para o servidor.

const LIMITE = 6;

const chave = (userId, empresaId) =>
  `@HubEverlog:tracking:recentes:${userId || "anon"}:${empresaId || "todas"}`;

export function lerRecentes(userId, empresaId) {
  try {
    const bruto = window.localStorage.getItem(chave(userId, empresaId));
    const lista = bruto ? JSON.parse(bruto) : [];
    return Array.isArray(lista) ? lista : [];
  } catch (_) {
    return [];
  }
}

export function salvarRecente(userId, empresaId, item) {
  try {
    const atual = lerRecentes(userId, empresaId).filter(
      (r) => !(r.tipo === item.tipo && r.valor === item.valor && r.cnpj === item.cnpj)
    );
    const lista = [{ ...item, em: new Date().toISOString() }, ...atual].slice(0, LIMITE);
    window.localStorage.setItem(chave(userId, empresaId), JSON.stringify(lista));
    return lista;
  } catch (_) {
    return lerRecentes(userId, empresaId);
  }
}

export function limparRecentes(userId, empresaId) {
  try {
    window.localStorage.removeItem(chave(userId, empresaId));
  } catch (_) {
    // storage bloqueado: nada a limpar
  }
  return [];
}

const pad = (n) => String(n).padStart(2, "0");

/** "hoje 09:12", "ontem 17:40" ou "27/09 11:05". */
export function quandoFoi(iso, agora = new Date()) {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return "";

  const hora = `${pad(data.getHours())}:${pad(data.getMinutes())}`;
  const inicioHoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());
  const inicioOntem = new Date(inicioHoje.getTime() - 24 * 60 * 60 * 1000);

  if (data >= inicioHoje) return `hoje ${hora}`;
  if (data >= inicioOntem) return `ontem ${hora}`;
  return `${pad(data.getDate())}/${pad(data.getMonth() + 1)} ${hora}`;
}
